import React, { Component } from "react";
class Prize extends Component {
  state = {
    gold: "一等奖",
    silver: "二等奖",
    bronze: "三等奖",
    good: "优秀奖"
  };
  render() {
    return (
      <div className="col-6 col-xl-3 text-center">
        <img
          src={require(`../assets/img/icon/${this.props.type}.svg`)}
          className="mb-3"
          alt=""
        />
        <h5>{this.state[this.props.type]}</h5>
        <div style={{ color: "#6C757D" }}>
          {this.props.detail}
        </div>
      </div>
    );
  }
}

export default Prize;
